import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import { useDispatch, connect, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";

import loginPage from "./loginPage";

import OtpInput from "react-otp-input";
import EditIcon from "@mui/icons-material/Edit";

import { useHistory } from "react-router-dom";
import { Formik } from "formik";
import {
  CheckOtpRequest,
  CheckOtpResponse,
  SendOtpResponse,
} from "../../models/security.model";
import * as Yup from "yup";
import { useMutation, useQueryClient } from "react-query";
import {
  GET_STORE_BY_SUPPLIER,
  MOBILE_NUMBER,
  OTP,
  REFERENCE_NUMBER,
  REFERENCE_NUMBER_SUPPLIER,
} from "../../config/cacheKey";
import { CheckOtp, sendOtp } from "../../services/security.service";
import { getTokenClaims, setJwtToken } from "../../services/auth.service";
import { Button, CircularProgress, Typography } from "@material-ui/core";
import { CountdownCmp } from "../../components/countdown/Countdown";
import LoginPage from "./loginPage";
import { ApiResultModel } from "../../models/common.model";
import { toast } from "react-toastify";
import AutoCompleteSearch from "../../components/autocomplete/autoCompleteSearch";
import { GetStatusResponse } from "../../models/basicInformation.model";
import { GetStoreBySupplier } from "../../services/branch.service";
import { StoreBySupplier } from "../../models/branch.model";

const _otp = () => {
  const queryClient = useQueryClient();
  const supplierId: GetStatusResponse[] = queryClient.getQueryData(
    REFERENCE_NUMBER_SUPPLIER
  )!;
  const [valueSupplierIds, setValueSupplierIds] = useState<string>();
  const [valueSupplier, setValueSupplier] = useState<any[]>([]);
  const [supplierIdsOptions, setSupplierIdsOptions] = React.useState<
    GetStatusResponse[]
  >(supplierId);
  const [otp, setOtp] = React.useState("");
  const [isBtnEnterClicked, setIsBtnEnterClicked] = React.useState<boolean>();
  const otpRef = useRef(0);
  const otpValid = Yup.object({
    otpNumber: Yup.string().required(),
  });
  const validationSchema = valueSupplierIds
    ? Yup.object().shape({
        supplierIds: Yup.string().required("فیلد اجباری می باشد"),
      })
    : null;

  const history = useHistory();
  const mobileNumber = queryClient.getQueryData<string>(MOBILE_NUMBER);
  const otpInfo = queryClient.getQueryData<SendOtpResponse>(OTP);
  useEffect(() => {
    if (!mobileNumber) {
      history.push("/login");
    }
  }, []);
  const GetStoreBySupplierMutation = useMutation(GetStoreBySupplier, {
    onSuccess: (data: StoreBySupplier[]) => {
      if (data) {
        localStorage.setItem(GET_STORE_BY_SUPPLIER, JSON.stringify(data));
      }
    },
  });
  const checkOptMutation = useMutation(CheckOtp, {
    onSuccess: (data: ApiResultModel<CheckOtpResponse>) => {
      if (data.isSuccess) {
        setJwtToken(data.data.jwt, data.data.refreshToken);
        history.push("/welcome");
        const supplierName = String(getTokenClaims()?.supplierName);
        const supplierUserFullName = String(
          getTokenClaims()?.supplierUserFullName
        );
        const nameHtmlData = `${supplierName} (${supplierUserFullName})`;
        const mobileHtmlData = String(getTokenClaims()?.mobileNumber);
        localStorage.setItem("nameHtmlData", nameHtmlData);
        localStorage.setItem("mobileHtmlData", mobileHtmlData);
        GetStoreBySupplierMutation.mutateAsync();
      } else if (!data.isSuccess && isBtnEnterClicked) {
        setOtp("");
        // otpRef.current.focusInput(otp.length)
        data.messages.map((message: any) => {
          toast.error(message.message);
        });
      }
    },
  });

  useEffect(() => {
    setIsBtnEnterClicked(true);
    if (otp.length === otpInfo?.otpLength! && !supplierId) {
      handleBtnClick(initValue);
    }
    if (otp.length === otpInfo?.otpLength! && valueSupplierIds) {
      handleBtnClick(initValue);
    }
  }, [otp]);

  // const sendOptMutation = useMutation(sendOtp, {
  //   onSuccess: (data: string) => {
  //     if (data) {
  //       queryClient.setQueryData(REFERENCE_NUMBER, data);
  //     }
  //   },
  // });
  const sendOptMutation = useMutation(sendOtp, {
    onSuccess: (data: SendOtpResponse) => {
      if (data) {
        queryClient.setQueryData(REFERENCE_NUMBER, data.key);
        queryClient.setQueryData(REFERENCE_NUMBER_SUPPLIER, data.suppliers);
        history.push("/otp");
      }
    },
  });

  function handleOnCompletedClick() {
    sendOptMutation.mutate({ mobileNumber });
  }
  function handleBtnClick(values: any) {
    values.key = queryClient.getQueryData(REFERENCE_NUMBER);
    values.supplierId = valueSupplierIds;
    values.otp = otp;
    checkOptMutation.mutate(values);
  }

  const mobileHandler = () => {
    history.push("/login");
  };
  function changeValueSupplierIds(e: any, value: any) {
    setValueSupplierIds(e);
    setValueSupplier(value);
  }
  const flag = true;
  const initValue = new CheckOtpRequest();
  initValue.otp = "";

  const jsonFile = useSelector((state: any) => state.style);
  return (
    <>
      <Box>
        <Typography
          className="iranSansFaNum"
          style={{
            color: "#1D4A87",
            fontSize: "fontSize",
            fontWeight: "bold",
            backgroundColor: "#F9FAFC",
            padding: "18px 30px",
            borderBottom: "1px solid #CFD8DC",
          }}
        >
          <img
            src={jsonFile?.loginLogo ? jsonFile?.loginLogo : "images/LOGOS.png"}
            style={{
              width: "24px",
              height: "24px",
              objectFit: "cover",
              marginLeft: "10px",
            }}
            alt="compony logo"
          />
          سامانه پذیرندگان ارزش آفرین ثمین
        </Typography>
      </Box>

      <Formik
        initialValues={initValue}
        // validationSchema={validationSchema}
        onSubmit={(values) => {
          values.key = queryClient.getQueryData(REFERENCE_NUMBER);
          values.otp = otp;
          // checkOptMutation.mutate(values);
          setIsBtnEnterClicked(true);
          handleBtnClick(values);
        }}
      >
        {({ handleSubmit, handleChange, values, errors }) => (
          <form onSubmit={handleSubmit}>
            <Box sx={{ paddingX: { xs: "1rem", sm: "2rem", md: "8rem" } }}>
              <div>
                <div
                  className="iranSansFaNum textCenter  colorBase  textFont22"
                  style={{
                    marginTop: "3vh",
                    marginBottom: "1vh",
                    display: "flex",
                    justifyContent: "center",
                    marginRight: "5px",
                  }}
                >
                  <EditIcon
                    className="cursorPointer"
                    style={{
                      color: jsonFile?.mainColor_300,
                      width: "24px",
                      height: "24px",
                    }}
                    onClick={mobileHandler}
                  />
                  <p>{mobileNumber}</p>
                </div>

                <Typography
                  variant="h6"
                  className="iranSansFaNum textCenter  fontWeight colorBase  textFont14 "
                  style={{ marginTop: "1vh" }}
                >
                  کد فعالسازی را وارد کنید
                </Typography>

                <div
                  dir="ltr"
                  className=" classCenter container "
                  style={{ marginTop: "5vh" }}
                >
                  <OtpInput
                    value={otp}
                    onChange={setOtp}
                    focusStyle={{ borderBottom: "3px solid #b6b5b5" }}
                    shouldAutoFocus={true}
                    numInputs={otpInfo?.otpLength!}
                    separator={<span></span>}
                    isInputNum={true}
                    inputStyle={{
                      width: "30px",
                      height: "35px",
                      margin: ".1px ",
                      fontSize: "24px",
                      dir: "ltr !important",
                      border: "none",
                      outline: "none",
                      borderBottom: "3px solid #1D4A87",
                      marginRight: "0px",
                      color: "#043D5D",
                      name: "otp",
                      id: "otp",
                    }}
                    className=" otp-input classCenter"
                  />
                </div>

                <Typography
                  className="iranSansFaNum textCenter iranSans-font  SuccessDefaultFont textFont15 fontWeight "
                  style={{ marginTop: "5vh" }}
                >
                  <CountdownCmp
                    countDownValue={otpInfo?.otpLifetime!}
                    onCompletedClick={() => handleOnCompletedClick()}
                    btnName="دریافت کد جدید"
                  />
                </Typography>
                {supplierId ? (
                  <div style={{ marginTop: "5vh" }}>
                    <b
                      style={{
                        margin: "0 5px 7px 0",
                        display: "inline-block",
                        color: "#28a745",
                      }}
                    >
                      &nbsp;پذیرنده خود را انتخاب کنید
                    </b>
                    <AutoCompleteSearch
                      id="supplierIds"
                      name="supplierIds"
                      value={valueSupplierIds}
                      // label=" پذیرنده*"
                      options={supplierIdsOptions}
                      onChange={changeValueSupplierIds}
                      changeMultiSelect={changeValueSupplierIds}
                      responseValue={valueSupplier}
                    />
                  </div>
                ) : null}
              </div>

              <Button
                style={{ marginTop: "5vh" }}
                onClick={undefined}
                fullWidth
                type="submit"
                variant="contained"
                // className="btnForm SuccessDefault Vazirmatn"
                disabled={
                  supplierId
                    ? !valueSupplierIds || otp.length < otpInfo?.otpLength!
                    : otp.length < otpInfo?.otpLength!
                }
                className={`${
                  supplierId
                    ? !valueSupplierIds || otp.length < otpInfo?.otpLength!
                      ? "btnForm deactivatedButton Vazirmatn "
                      : "btnForm activatedButton Vazirmatn "
                    : otp.length < otpInfo?.otpLength!
                    ? "btnForm deactivatedButton Vazirmatn "
                    : "btnForm activatedButton Vazirmatn "
                }`}
              >
                ورود
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </>
  );
};

export default function Otp() {
  const jsonFile = useSelector((state: any) => state.style);
  const childForm = <_otp />;

  return (
    <>
      {/* <img
        src={jsonFile?.loginLogo ? jsonFile.loginLogo : "images/LOGO.png"}
        className=" classCenter"
        style={{
          marginTop: "5vh",
          marginBottom: "revert",
          width: "140px",
          height: "100px",
          objectFit: "contain",
        }}
      /> */}
      <Box sx={{ flexGrow: 2, overflow: "hidden", px: 3 }}>
        <LoginPage childForm={childForm} />
      </Box>
    </>
  );
}
